var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15 8.33325L10.5893 12.744C10.2638 13.0694 9.73618 13.0694 9.41074 12.744L5 8.33325",
    stroke: "#49A942",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGreen);
export default __webpack_public_path__ + "static/media/chevronDownGreen.a60ed59537f563879c3d78891ff8ac20.svg";
export { ForwardRef as ReactComponent };